import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import UserTestingArtwork from 'marketing-website/components/modules/UserTestingArtwork';

export default function Devices() {
  return (
    <div className="shape bg-marvel">
      <PageWrap size="l">
        <Spacing size="xl" type="padding" position="topBottom">
          <Grid columns={12} alignItems="center">
            <GridItem columnSpan={12} columnSpanM={7}>
              <UserTestingArtwork
                color="marvelLight"
                patternColor="marvelExtraLight"
              />
            </GridItem>
            <GridItem columnSpan={12} columnSpanM={5}>
              <Spacing size="m" type="margin" position="bottom">
                <HeadingBlock
                  color="white"
                  justifyContent="center"
                  justifyM="start"
                  maxWidth={460}
                  title="Record feedback and test your idea"
                  copy="Ready to show the world? POP allows you to instantly get feedback on your ideas with user testing, commenting and collaboration tools."
                />
              </Spacing>
            </GridItem>
          </Grid>
        </Spacing>
      </PageWrap>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Record.js